/** True only for an absolute http(s) URL. "http" inside a data URL or SVG is not hosted. */
export function isHostedHttpUrl(value) {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  return trimmed.startsWith("http://") || trimmed.startsWith("https://");
}
